import { MouseEvent } from 'react';
import { useToggle } from 'react-use';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import {
  ColumnSettingsModal,
  TableColumnsSectionType,
} from 'src/modals/ColumnSettings/ColumnSettings';
import { LayoutIcon } from 'src/svgs';

export const ColumnPicker = ({
  variant,
  tableColumnsSectionType,
}: {
  variant?: 'compact';
  tableColumnsSectionType: TableColumnsSectionType;
}) => {
  const [isColumnModalOpen, toggleColumnModal] = useToggle(false);
  const onColumnSettingButtonClickHandler = (
    e: MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();
    if (!isColumnModalOpen) toggleColumnModal(true);
  };

  return (
    <>
      <Stack justifyContent="end">
        <Button
          variant="textPlain"
          onClick={onColumnSettingButtonClickHandler}
          style={{ padding: vars.spacing.xs, paddingRight: 0 }}
        >
          <LayoutIcon size={vars.iconSize.m} />
        </Button>
      </Stack>
      {isColumnModalOpen ? (
        <ColumnSettingsModal
          onClose={toggleColumnModal}
          sectionType={tableColumnsSectionType}
        />
      ) : null}
    </>
  );
};
